import React from "react";
import Navbar from "../components/universal/navbar";
import Footer from "../components/universal/footer";
import Header from "../components/thank-you/header";
import { Helmet } from "react-helmet";
const Thankyou = () => {
  return (
    <>
      <Helmet>
        <title>Dental Implants in Ilkley | Thank You</title>
        <link
          rel="canonical"
          href="https://www.dentalimplants-ilkley.com/thank-you"
        />
      </Helmet>
      <Navbar />
      <Header heading />
      <Footer />
    </>
  );
};

export default Thankyou;
